import React from 'react';
import PropTypes from 'prop-types';
import { allowedMessageProps, MessageListArea } from '../lists/SystemMessages';

const Notification = ({ newMessage }) => (
  <aside className='area-notification'>
    <MessageListArea newMessage={newMessage} />
  </aside>
);

Notification.propTypes = { newMessage: PropTypes.shape(allowedMessageProps) };

export default Notification;